module.exports = __webpack_public_path__ + "img/2c.434a33bc.png";